export default "__VITE_ASSET__DDVP8UKH__"